export default __webpack_public_path__ + "static/media/cards6.4cbb08af.png";